export default __webpack_public_path__ + "static/padmini2-58c82af9df2533cdf6b88eef470cfdd8.jpg";